 // 禁用 Everyday Fitness 区域卡片 hover 图片切换
document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('#shopify-section-template--21532272427139__featured_collection_mn6CrQ');
  if (!section) return;

  section.querySelectorAll('.media--hover-effect').forEach(function (mediaEl) {
    const imgs = mediaEl.querySelectorAll('img');
    if (imgs.length > 1) {
      for (let i = 1; i < imgs.length; i++) {
        imgs[i].remove();
      }
      mediaEl.classList.remove('media--hover-effect');
    }
  });
});

// Cart drawer - clamp variant text to 2 lines with ellipsis
(function () {
  const VARIANT_STYLE_ID = 'rf-variant-clamp-style';

  function injectStyle() {
    if (document.getElementById(VARIANT_STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = VARIANT_STYLE_ID;
    style.textContent = `
      cart-drawer .cart-item__variants {
        max-height: calc(2em * 1.5) !important;
        line-height: 1.5 !important;
        overflow: hidden !important;
        position: relative !important;
      }
      cart-drawer .cart-item__variants::after {
        content: '...' !important;
        position: absolute !important;
        bottom: 0 !important;
        right: 0 !important;
        background: white !important;
        padding-left: 6px !important;
      }
      cart-drawer .cart-item__variants .product-option {
        display: inline !important;
      }
      cart-drawer .cart-item__variants dt,
      cart-drawer .cart-item__variants dd {
        display: inline !important;
      }
    `;
    document.head.appendChild(style);
  }

  injectStyle();

  if (window._variantObserver) window._variantObserver.disconnect();
  window._variantObserver = new MutationObserver(injectStyle);
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    window._variantObserver.observe(cartDrawer, { childList: true, subtree: true });
  }
})();
